module.exports = __webpack_public_path__ + "img/bbdc-3.d8e7561e.jpg";